import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {
    marginBottom: 20,
    paddingBottom: 20,
    borderRadius: 5,
    backgroundColor: theme.palette.common.white,
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 20px 0',
  },
  alert: {
    margin: "20px 20px 0",
  },
  section: {
    padding: '10px 20px',
  },
  sectionTitle: {
    color: theme.palette.common.black,
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  inputContainer: {
    flex: 1,
    minWidth: 0,
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 20,
    gap: 25,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 50,
  },
}));
